import styled from 'styled-components';

export const ActionsRoot = styled.div`
  display: flex;
  justify-content: flex-end;
`;
